import { createFeatureSelector } from '@ngrx/store';

export const collectionTypeState = createFeatureSelector<OLO.State, OLO.State.CollectionType>('collectionType');
